import { React, useState, useEffect, createContext, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import request from "../../../../Helpers/API";
import {
    TextField,
    MenuItem,
    InputAdornment,
    Modal,
    Box
} from "@mui/material";
import Swal from "sweetalert2";
// import { LoaderScreen } from "../../components/LoaderScreen";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from '@mui/icons-material/Edit';

const EditarDatosContactoModal = ({ open, handleCloseModalEditar, idmedio }) => {
    const [datosContacto, setDatosContacto] = useState({
        idmedio: idmedio,
        mediocontacto: "",
        medio: "",
        responsable: "",
        comentarios: ""
    });

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    useEffect(() => {
        if (open && idmedio) {
            setLoader({ ...loader, mostrar: true });
            request
                .get(`ObtenerDatosContactoCliente/DatosMedio?idmedio=${idmedio}`)
                .then((result) => {
                    setDatosContacto({
                        ...datosContacto,
                        mediocontacto: result[0].medio_contacto.trim(), // Ensure a valid default value like "T" (Teléfono)
                        medio: result[0].medio,
                        responsable: result[0].responsable_pago,
                        comentarios: result[0].comentarios,
                    });
                    setLoader({ ...loader, mostrar: false });
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
                });
        }
    }, [open, idmedio]);

    const EditarContacto = () => {
        if (datosContacto.mediocontacto === "" || datosContacto.mediocontacto === null || datosContacto.mediocontacto === undefined) {
            Swal.fire({
                title: "AGREGAR CONTACTO",
                text: "SELECCIONE EL MEDIO DE CONTACTO",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }
        if (datosContacto.medio === "" || datosContacto.medio === null || datosContacto.medio === undefined) {
            Swal.fire({
                title: "AGREGAR CONTACTO",
                text: "SE NECESITA AGREGAR EL CORREO O TELEFONO",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return; // Detiene la ejecución si no hay facturas seleccionadas
        }

        setLoader({ ...loader, mostrar: true });
        request
            .get(`ObtenerDatosContactoCliente/EditarDatos?idmedio=${idmedio}&medio_contacto=${datosContacto.mediocontacto}&medio=${datosContacto.medio}&comentarios=${datosContacto.comentarios}&usuario=0&responsable_pago=${datosContacto.responsable}`)
            .then(async (result) => {
                setLoader({ ...loader, mostrar: false });
                setDatosContacto({
                    ...datosContacto,
                    idmedio: -99,
                    mediocontacto: "",
                    medio: "",
                    comentarios: "",
                    responsable: ""
                })
                await Swal.fire({
                    title: "EDITAR CONTACTO",
                    text: "Registro guardado con éxito",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });
                handleCloseModalEditar()
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
            });
    };

    const getMedioContacto = (medio) => {
        switch (medio) {
            case 'W ' || 'W':
                return 'Whatsapp';
            case 'C ' || 'C':
                return 'Correo';
            case 'P ' || 'P':
                return 'Página web';
            case 'T ' || 'T':
                return 'Teléfono';
            default:
                return medio;
        }
    };
    // console.log(datosContacto)


    return (
        <Modal open={open} onClose={handleCloseModalEditar}>
            <div className="plantilla-screen-filtro-container-modal-container">
                <div className="agregar-contacto-modal">
                    <div className="agregar-contacto-modal-detalle">
                        <div className="agregar-contacto-modal-detalle-formulario">
                            <div className="agregar-contacto-modal-formulario-plantilla">
                                <div className="plantilla-screen-filtro-container" id="mdlFiltros-modal">
                                    <PlantillaScreen
                                        titulo={`Editar Datos de Contacto`}
                                        className_main={1}
                                        className={"plantilla-screen-filtro-container-modal"}
                                    >
                                        <div className="cerrar-modal-button" onClick={handleCloseModalEditar}>X</div>
                                        <div
                                            className={`agregar-contacto-modal-formulario-plantilla-agregar`}
                                        >
                                            <div className="agregar-contacto-modal-formulario-plantilla-container scroll-4">

                                                <Box display="flex" sx={{ mt: 2 }}>
                                                    <TextField
                                                        className="input-medio-comunicacion"
                                                        fullWidth
                                                        size="small"
                                                        label="Medio de Contacto"
                                                        select
                                                        value={datosContacto.mediocontacto} // Fallback to "T" (Teléfono) if undefined
                                                        onChange={(e) => {
                                                            setDatosContacto({
                                                                ...datosContacto,
                                                                mediocontacto: e.target.value,
                                                            });
                                                        }}
                                                        sx={{ flex: 1, mr: 1 }}
                                                    >
                                                        <MenuItem value={"T"}>Teléfono</MenuItem>
                                                        <MenuItem value={"W"}>WhatsApp</MenuItem>
                                                        <MenuItem value={"C"}>Correo</MenuItem>
                                                        <MenuItem value={"P"}>Página Web</MenuItem>
                                                    </TextField>
                                                    <TextField
                                                        id="outlined-multiline-static"
                                                        size="small" // Añade size="small" aquí
                                                        label={
                                                            datosContacto.mediocontacto === "C"
                                                                ? "Correo"
                                                                : datosContacto.mediocontacto === "P"
                                                                    ? "Página Web"
                                                                    : "Teléfono"
                                                        }
                                                        value={datosContacto.medio}
                                                        onChange={(e) => {
                                                            setDatosContacto({
                                                                ...datosContacto,
                                                                medio: e.target.value,
                                                            });
                                                        }}
                                                        inputProps={{
                                                            type: datosContacto.mediocontacto === "T" || datosContacto.mediocontacto === "W" ? 'number' : 'text',
                                                            style: { height: '23px' },
                                                            onInput: (e) => {
                                                                if (datosContacto.mediocontacto === "T" || datosContacto.mediocontacto === "W") {
                                                                    const value = e.target.value.replace(/[^0-9]/g, ''); // Eliminar caracteres no numéricos
                                                                    // Limitar longitud a 10
                                                                    if (value.length <= 10) {
                                                                        e.target.value = value;
                                                                    } else {
                                                                        e.target.value = value.slice(0, 10);
                                                                    }
                                                                }
                                                            }
                                                        }}
                                                        sx={{ flex: 1 }} // Mantén flex: 1 aquí
                                                    />
                                                </Box>

                                                <TextField
                                                    id="outlined-multiline-static"
                                                    label="Responsable de Pago"
                                                    sx={{ mt: 2 }}
                                                    value={datosContacto.responsable || ""} // Ensure it defaults to an empty string
                                                    onChange={(e) => {
                                                        setDatosContacto({
                                                            ...datosContacto,
                                                            responsable: e.target.value || "" // Send empty string if no input
                                                        });
                                                    }}
                                                />

                                                <TextField
                                                    id="outlined-multiline-static"
                                                    label="Comentarios"
                                                    sx={{ mt: 2 }}
                                                    value={datosContacto.comentarios || ""} 
                                                    onChange={(e) => {
                                                        setDatosContacto({
                                                            ...datosContacto,
                                                            comentarios: e.target.value || "" 
                                                        });
                                                    }}
                                                />
                                            </div>
                                            <div className="agregar-contacto-modal-buttons">
                                                <button
                                                    className="agregar-contacto-modal-button-guardar"
                                                    onClick={() => EditarContacto()}
                                                >
                                                    Editar
                                                </button>
                                            </div>


                                        </div>
                                    </PlantillaScreen>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal >
    );
};


export default EditarDatosContactoModal;